export default class developerSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/developer-settings.html'),
            controller: DeveloperSettingsCtrl,
            controllerAs: 'dev'
        }
    }
};

class DeveloperSettingsCtrl {
    constructor($scope, $filter, Setting, Events, SweetAlert) {
        this._translator = $filter('translate');

        this._filter = $filter;
        this.settingsRepo = Setting;
        this.eventHandler = Events;
        this.alerter = SweetAlert;

        this.loadingApiKeys = true;
        this.loadingWebHooks = true;
        this.showWebHookOverlay = false;

        this.settingsRepo.allApiKeys().then((apiKeys) => {
            this.loadingApiKeys = false;
            this.apiKeys = apiKeys;
        });

        this.settingsRepo.getWebhookEvents().then((response) => {
            this.webhookEvents = response.data;
        });

        this.settingsRepo.getWebhooks().then((response) => {
            this.webhooks = response.data;
            this.loadingWebHooks = false;
        });

        $scope.$on('setting:newWebHook', () => {
            this.settingsRepo.getWebhooks().then((webHooks) => {
                this.webhooks = webHooks.data;
            });
        });
    }

    createApiKey() {
        let newApiKeyName = this._filter('getNumberedName')(this.apiKeys.map(key => key.name), 'New');
        this.settingsRepo.createApiKey(newApiKeyName).then((apiKey) => {
            this.apiKeys.push(apiKey);
            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:API_KEY_CREATE'));
        }, error => {
            let errorMessage = this._translator('SETTING:FLASH:API_KEY_CREATE_FAILED');
            if (error.data && error.data.code === 9) {
                errorMessage = error.data.message || errorMessage;
            }
            this.eventHandler.flashEvent('error', errorMessage);
        })
    };

    removeApiKey(key) {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:DELETE'),
            text: this._translator('SETTING:FLASH:DELETE_API_KEY_BODY'),
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                key.remove().then(() => {
                    angular.forEach(this.apiKeys, (apiKey, index) => {
                        if (apiKey && apiKey.id == key.id) {
                            this.apiKeys.splice(index, 1);
                        }
                    });

                    this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:API_KEY_DELETE'));
                });
            }
        });
    };

    updateApiKey(key, $data) {
        key.name = $data;

        key.put().then(() => {
            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:API_KEY_UPDATE'));
        }, (error) => {
            this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:API_KEY_UPDATE_FAILED'))
        })
    };


    toggleWebHookOverlay() {
        this.showWebHookOverlay = ! this.showWebHookOverlay;
    };

    updateWebhook(webhook) {
        this.settingsRepo.updateWebhook(webhook).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('GLOBAL:UPDATED'));
        }, (error) => {
            this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:WEBHOOK_UPDATE_FAILED'));
        });
    };

    testCall(webhook) {
        this.settingsRepo.testCallWebhook(webhook.event).then(() => {
            let flashText = this._translator('SETTING:FLASH:WEBHOOK_TEST_SUCCESS');
            this.eventHandler.flashEvent('notification', flashText.replace(':url', webhook.url));
        }, (error) => {
            this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:WEBHOOK_TEST_FAILED'));
        });
    };

    deleteWebhook(webHook) {
        this.alerter.swal({
            title: this._translator('GLOBAL:DELETE'),
            text: this._translator('SETTING:FLASH:DELETE_WEBHOOK_BODY'),
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.settingsRepo.deleteWebhook(webHook.id).then(() => {
                    angular.forEach(this.webhooks, (hook, index) => {
                        if (hook && hook.id == webHook.id) {
                            this.webhooks.splice(index, 1);
                        }
                    });

                    this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:WEBHOOK_DELETED'));
                }, (error) => {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:WEBHOOK_DELETE_FAILED'));
                });
            }
        });
    };
}
